module.exports = __webpack_public_path__ + "images/2023_background_1ade1cf193692bf199745babc344818db.gif";